import React from "react";

const AffableConnectedIcon: React.FC = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9695 1.68671C14.0658 1.54039 14.0256 1.34315 13.8758 1.25228C12.7886 0.592538 11.5679 0.180502 10.3005 0.0472887C8.92797 -0.0969891 7.5408 0.0900066 6.25541 0.592588C4.97003 1.09517 3.82392 1.89868 2.91323 2.93571C2.07238 3.89322 1.45486 5.02401 1.10352 6.24621C1.05513 6.41456 1.15934 6.58679 1.32936 6.62897L1.46377 6.66231C1.6338 6.70449 1.80518 6.60063 1.85419 6.43245C2.17538 5.33015 2.73465 4.31031 3.49394 3.44568C4.32309 2.50151 5.36657 1.76995 6.53685 1.31238C7.70713 0.854798 8.97008 0.684547 10.2198 0.815905C11.3642 0.936198 12.4669 1.30621 13.4506 1.8983C13.6006 1.98864 13.797 1.9487 13.8933 1.80238L13.9695 1.68671Z"
        fill="url(#paint0_linear_6126_3094)"
      />
      <path
        d="M1.08869 8.37533C0.913602 8.36995 0.76669 8.50757 0.767745 8.68274C0.775919 10.0394 1.10389 11.3767 1.72691 12.5853C2.39843 13.888 3.39061 14.9982 4.60992 15.8113C5.82924 16.6244 7.23552 17.1136 8.69622 17.2328C10.0514 17.3434 11.4121 17.1322 12.6677 16.6183C12.8298 16.5519 12.9004 16.3634 12.8281 16.2038L12.771 16.0776C12.6987 15.9181 12.511 15.8479 12.3486 15.9137C11.2127 16.3738 9.98348 16.5625 8.75909 16.4625C7.42919 16.354 6.14884 15.9086 5.03871 15.1683C3.92858 14.428 3.02525 13.4172 2.41386 12.2312C1.85097 11.1393 1.55262 9.93196 1.54081 8.70649C1.53912 8.53132 1.40221 8.38497 1.22712 8.37959L1.08869 8.37533Z"
        fill="url(#paint1_linear_6126_3094)"
      />
      <circle
        cx="1.29515"
        cy="8.48461"
        r="1.29515"
        fill="url(#paint2_linear_6126_3094)"
      />
      <path
        d="M13.6206 15.7923C13.7095 15.9432 13.9043 15.9939 14.0519 15.8994C15.0443 15.2641 15.897 14.4316 16.5566 13.4524C17.2753 12.3855 17.7463 11.1714 17.9354 9.89892C18.1244 8.62646 18.0266 7.32785 17.6491 6.09807C17.3026 4.96946 16.7287 3.92502 15.9638 3.02864C15.8501 2.89538 15.649 2.88727 15.52 3.00579L15.418 3.09949C15.289 3.21801 15.2811 3.41826 15.3943 3.55192C16.0815 4.36319 16.5976 5.30638 16.9103 6.32486C17.2539 7.44452 17.343 8.62684 17.1709 9.78535C16.9988 10.9439 16.5699 12.0492 15.9156 13.0207C15.3204 13.9043 14.5524 14.6567 13.659 15.2332C13.5119 15.3282 13.4613 15.5221 13.5502 15.673L13.6206 15.7923Z"
        fill="url(#paint3_linear_6126_3094)"
      />
      <circle
        cx="13.5881"
        cy="1.66625"
        r="1.29515"
        fill="url(#paint4_linear_6126_3094)"
      />
      <circle
        cx="14.4045"
        cy="15.2268"
        r="1.29515"
        fill="url(#paint5_linear_6126_3094)"
      />
      <path
        d="M5.42578 7.98538C5.42578 7.55227 5.77688 7.20117 6.20999 7.20117H8.86649V8.47551C8.86649 8.90861 8.51539 9.25971 8.08228 9.25971H5.42578V7.98538Z"
        fill="url(#paint6_linear_6126_3094)"
      />
      <path
        d="M9.64258 5.1846C9.64258 4.75149 9.99368 4.40039 10.4268 4.40039H13.8038V5.80706C13.8038 6.24017 13.4527 6.59127 13.0196 6.59127H9.64258V5.1846Z"
        fill="url(#paint7_linear_6126_3094)"
      />
      <path
        d="M13.6807 5.8125C13.6807 6.24561 13.3296 6.59668 12.8965 6.59668H10.4423C10.107 6.59668 9.78589 6.73195 9.55162 6.97187L9.26045 7.27007C9.03337 7.50262 8.90625 7.81477 8.90625 8.13981V8.31738C8.90625 8.75049 8.55518 9.10156 8.12207 9.10156H6.79785C6.14849 9.10156 5.62207 8.57515 5.62207 7.92578C5.62207 7.49268 5.97412 7.1416 6.40723 7.1416H8.23135C8.56675 7.1416 8.88796 7.00627 9.12223 6.76625L9.27877 6.60588C9.50575 6.37334 9.63281 6.06126 9.63281 5.7363V5.4209C9.63281 4.98779 9.98389 4.63672 10.417 4.63672H12.5049C13.1542 4.63672 13.6807 5.16313 13.6807 5.8125Z"
        fill="url(#paint8_linear_6126_3094)"
      />
      <path
        d="M5.05664 11.626C5.05664 11.1929 5.40774 10.8418 5.84085 10.8418H8.49735V12.1161C8.49735 12.5492 8.14625 12.9003 7.71314 12.9003H5.05664V11.626Z"
        fill="url(#paint9_linear_6126_3094)"
      />
      <path
        d="M9.64453 8.87014C9.64453 8.43704 9.99563 8.08594 10.4287 8.08594H13.8057V9.39948C13.8057 9.83259 13.4546 10.1837 13.0215 10.1837H9.64453V8.87014Z"
        fill="url(#paint10_linear_6126_3094)"
      />
      <path
        d="M13.5312 9.4082C13.5312 9.84131 13.1802 10.1924 12.7471 10.1924H10.1013C9.76611 10.1924 9.44509 10.3275 9.21085 10.5673L8.89159 10.894C8.66434 11.1266 8.53711 11.4389 8.53711 11.7641V11.9414C8.53711 12.3745 8.18603 12.7256 7.75293 12.7256H6.42871C5.77934 12.7256 5.25293 12.1992 5.25293 11.5498C5.25293 11.1167 5.60498 10.7656 6.03809 10.7656H7.86302C8.19851 10.7656 8.51981 10.6302 8.7541 10.3901L9.12955 10.0053C9.35641 9.77273 9.4834 9.46074 9.4834 9.13588V9.0166C9.4834 8.5835 9.83447 8.23242 10.2676 8.23242H12.3555C13.0048 8.23242 13.5312 8.75884 13.5312 9.4082Z"
        fill="url(#paint11_linear_6126_3094)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6126_3094"
          x1="4.09556"
          y1="2.55066"
          x2="17.7347"
          y2="17.4918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5B5B5B" />
          <stop offset="1" stop-color="#969696" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6126_3094"
          x1="4.09556"
          y1="2.55066"
          x2="17.7347"
          y2="17.4918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5B5B5B" />
          <stop offset="1" stop-color="#969696" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6126_3094"
          x1="0.499407"
          y1="7.57221"
          x2="2.54614"
          y2="9.81433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5B5B5B" />
          <stop offset="1" stop-color="#969696" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6126_3094"
          x1="4.09556"
          y1="2.55066"
          x2="17.7347"
          y2="17.4918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5B5B5B" />
          <stop offset="1" stop-color="#969696" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6126_3094"
          x1="12.7924"
          y1="0.753854"
          x2="14.8391"
          y2="2.99597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5B5B5B" />
          <stop offset="1" stop-color="#969696" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6126_3094"
          x1="13.6088"
          y1="14.3144"
          x2="15.6555"
          y2="16.5565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5B5B5B" />
          <stop offset="1" stop-color="#969696" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6126_3094"
          x1="8.92237"
          y1="8.88371"
          x2="7.05845"
          y2="6.70549"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B7ECF3" />
          <stop offset="0.101298" stop-color="#C8F2F9" />
          <stop offset="0.212167" stop-color="#C1F0F7" />
          <stop offset="0.404566" stop-color="#97E1EB" />
          <stop offset="0.690308" stop-color="#42C4D3" />
          <stop offset="1" stop-color="#1CB7C8" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6126_3094"
          x1="9.69673"
          y1="4.75206"
          x2="13.0147"
          y2="6.08898"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CAF3F9" />
          <stop offset="0.329525" stop-color="#A4E5ED" />
          <stop offset="0.433301" stop-color="#84D9E3" />
          <stop offset="0.663462" stop-color="#4FC5D2" />
          <stop offset="1" stop-color="#1AB0C1" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6126_3094"
          x1="5.7279"
          y1="5.3534"
          x2="12.2412"
          y2="7.84702"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0865385" stop-color="#08AFC2" />
          <stop offset="0.485577" stop-color="#DBFAFF" />
          <stop offset="1" stop-color="#1AB0C1" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_6126_3094"
          x1="8.48968"
          y1="12.4774"
          x2="6.72588"
          y2="10.059"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#84D0DC" />
          <stop offset="0.151897" stop-color="#4AC7D7" />
          <stop offset="0.33723" stop-color="#1CB6CA" />
          <stop offset="0.754499" stop-color="#1285A1" />
          <stop offset="1" stop-color="#0D809D" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_6126_3094"
          x1="13.2343"
          y1="8.27341"
          x2="9.2715"
          y2="8.12512"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0A829D" />
          <stop offset="0.270676" stop-color="#19ADC2" />
          <stop offset="0.42331" stop-color="#2CC3D4" />
          <stop offset="0.677455" stop-color="#81D0DC" />
          <stop offset="0.863818" stop-color="#93D2DD" />
          <stop offset="1" stop-color="#15A4B4" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_6126_3094"
          x1="5.36162"
          y1="8.95365"
          x2="12.0168"
          y2="11.5546"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.110577" stop-color="#0C7E9B" />
          <stop offset="0.370192" stop-color="#1FC1D3" />
          <stop offset="0.596154" stop-color="#95D3DD" />
          <stop offset="0.776982" stop-color="#1FC1D3" />
          <stop offset="1" stop-color="#0A829D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AffableConnectedIcon;
